<i18n>
{
  "en": {
    "browser_title": "Home",
    "recommended_sites": "Recommended Sites",
    "click_to_join": "Click Here To Join"
  },
  "ja": {
    "browser_title": "トップページ",
    "recommended_sites": "おすすめサイト情報",
    "click_to_join": "入会はこちら"
  }
}
</i18n>

<template>
  <main>
    <vue-headful v-bind:title="dynamicTitle" />

    <hero-image />

    <div id="toppage" class="page-margin">
      <!-- "top" movies: randomly selected from BOB list -->
      <section class="top-pick" v-if="staffPicksEnabled">
        <random-bob :num-movies="8"/>
      </section>

      <!-- newest movies -->
      <section class="top-movies">
        <latest-list
          :num-movies="newMovieListSize" />
      </section>

      <!-- popular categories -->
      <section class="top-category" v-if="recommendedCategoriesEnabled">
        <recommended-categories :categories="'風俗嬢,盗撮,巨乳,アナル,パイパン,10代,ニューハーフ,野外露出,どっきり,女子校生,女子大生,乱交,OL,痴女,SM,ナンパ,カップル,メイド'" />
      </section>

      <!-- recommended sites -->
      <section class="top-dlsite" v-if="recommendedSitesEnabled">
        <div class="container">
          <div class="section">
            <h2>{{ $t('recommended_sites') }}</h2>
            <site-movie-list site-name="carib" :num-movies="recommendedSitesMovieListSize" :movie-offset="recommendedSitesOffset" />
            <site-movie-list site-name="1pon" :num-movies="recommendedSitesMovieListSize" :movie-offset="recommendedSitesOffset" />
            <site-movie-list site-name="10m" :num-movies="recommendedSitesMovieListSize" :movie-offset="recommendedSitesOffset" />
            <site-movie-list site-name="paco" :num-movies="recommendedSitesMovieListSize" :movie-offset="recommendedSitesOffset" />
          </div>
        </div>
      </section>

      <!-- PR -->
      <section class="top-pr" v-if="prEnabled && hasPR">
        <pr-list @prEval="prEval"/>
      </section>
    </div>

    <div class="mobile-join">
      <router-link class="button is-filled is-color-main is-fullwidth" to="/join/">{{ $t('click_to_join') }}<i class="iconf-arrow-right is-right"></i></router-link>
    </div>

  </main>
</template>

<script>
/* eslint max-len: 0 */

// @ is an alias to /src
import vueHeadful from 'vue-headful';
import APP_CONFIG from '@/appConfig';

import SiteConfig from '@/assets/js/utils/SiteConfig';
import lazyLoadComponent from '@/assets/js/utils/lazyLoadComponent';
import SkeletonBox from '@/components/_shell/SkeletonBox.vue';

import HeroImage from '@/components/home/heroImage.vue';
import RandomBOB from '@/components/home/randomBob.vue';
import LatestList from '@/components/home/latestList.vue';
import RecommendedCategories from '@/components/home/recommendedCategories.vue';

const skeletonOptions = {
  loading: SkeletonBox,
  loadingData: {
    props: {
      width: '100%',
      height: '20em',
    },
  },
};

export default {
  name: 'Home',

  components: {
    'vue-headful': vueHeadful,
    'hero-image': HeroImage,
    'random-bob': RandomBOB,
    'latest-list': LatestList,
    'recommended-categories': RecommendedCategories,
    'site-movie-list': lazyLoadComponent({
      ...skeletonOptions,
      componentFactory: () => import('@/components/home/siteMovieList.vue'),
    }),
    'pr-list': lazyLoadComponent({
      ...skeletonOptions,
      componentFactory: () => import('@/components/home/PR.vue'),
    }),
  },
  data() {
    return {
      config: {},
      hasPR: true,
      dynamicTitle: '',
    };
  },

  async created() {
    // set browser title
    this.dynamicTitle = `${this.$t('browser_title')} ${APP_CONFIG.site.title[this.locale]}`;

    // we have the title, now send the page view
    this.$analytics.trackPage(this.$route.fullPath, this.dynamicTitle);

    // get site config (settings from admin)
    this.config = await SiteConfig.getConfig('home');
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    },
    isSiteMember() {
      return this.$store.getters['user/isSiteMember'];
    },
    // set default site configs below, in case the app fails to fetch the config json file
    staffPicksEnabled() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'staffPicksEnabled') ? this.config.staffPicksEnabled : true);
    },
    newMovieListSize() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'newMovieListSize') ? this.config.newMovieListSize : 6);
    },
    recommendedCategoriesEnabled() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'recommendedCategories') ? this.config.recommendedCategories : true);
    },
    recommendedSitesEnabled() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'recommendedSites') ? this.config.recommendedSites : true);
    },
    recommendedSitesMovieListSize() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'recommendedSitesMovieListSize') ? this.config.recommendedSitesMovieListSize : 10);
    },
    recommendedSitesOffset() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'recommendedSitesOffset') ? this.config.recommendedSitesOffset : 0);
    },
    prEnabled() {
      return (Object.prototype.hasOwnProperty.call(this.config, 'prEnabled') ? this.config.prEnabled : true);
    },
  },

  methods: {
    prEval(value) {
      this.hasPR = value;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/_home.scss';
</style>
